import { Pagination, Spin } from "antd";
import PendingAdsComp from "../../../../components/common/pendingAdCard";
import { useCallback, useEffect, useState } from "react";
import { getAds } from "../../../../api/ads";
import AdsServiceCard from "../../../../components/common/adsServiceCard";
import { LoadingOutlined } from "@ant-design/icons";

const PendingAds = ({ data, openModal }) => {
  const [allAds, setAllAds] = useState();
  const [pageSize, setPagesize] = useState(4);
  const [loader, setLoader] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);

  const adsList = useCallback(async () => {
    setLoader(true);
    const filter = "PENDING";
    const res = await getAds(currentPage, pageSize, filter);
    setAllAds(res);
    setLoader(false);
  }, [currentPage, pageSize]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSizeChange = (current, size) => {
    setPagesize(size);
  };
  const onlyPendingAds = allAds?.items?.filter(
    (item) => item?.isApproved === "PENDING"
  );

  useEffect(() => {
    adsList();
  }, [currentPage, pageSize, adsList]);
  if (!loader && onlyPendingAds?.length === 0) {
    return (
      <div className="text-xl flex justify-center h-screen items-center opacity-50">
        No Pending Ads.
      </div>
    );
  }
  return (
    <>
      {loader ? (
        <div className="flex h-screen justify-center items-center">
          <Spin
            indicator={<LoadingOutlined />}
            className="flex justify-center"
            size="large"
          />
        </div>
      ) : (
        <div>
          {onlyPendingAds?.map((item, i) => {
            return (
              <div
                className="m-2 gap-2 grid grid-cols-1 lg:grid-cols-4"
                key={i}
              >
                <div className=" col-span-1">
                  <AdsServiceCard data={item} />
                </div>
                <div className=" col-span-3">
                  <PendingAdsComp data={item} loader={loader} />
                </div>
              </div>
            );
          })}

          <div className="flex justify-center items-center pagination-container mb-2">
            <Pagination
              current={currentPage}
              total={allAds?.totalItems}
              pageSize={pageSize}
              showQuickJumper={true}
              pageSizeOptions={[4, 10, 20, 30]}
              onShowSizeChange={handleSizeChange}
              onChange={(e) => {
                handlePageChange(e);
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};
export default PendingAds;
